import React from 'react';
import classes from './Error.module.scss';
import ThinkingEmoji from '../../../images/thinking-emoji.svg';
import CatchHeader from '../CatchHeader/CatchHeader';
import Button from '../../UI/Button/Button';

const Error = (props) => {
    let title;
    let description;
    if(props.status === 403)  {
        title = props.title?? 'This page is unavailable';
        description = props.description?? 'Sorry, we are unable to process your request at this time.';
        return (
            <div className={classes.ErrorContainer}>
                <CatchHeader />
                <div className={classes.ErrorImageContainer}>
                    <img src={ThinkingEmoji} alt='thinking-emoji' />
                </div>
                <div className={classes.ErrorTitle}>{title}</div>
                <div className={classes.ErrorDescription}>
                    <p>
                        {description}
                    </p>
                </div>
            </div>
        );        
    } else {
        title = props.title?? 'Oops!';
        description = props.description?? 'There was a problem loading this webpage';
        return (
            <div className={classes.ErrorContainer}>
                <div className={classes.ErrorImageContainer}>
                    <img src={ThinkingEmoji} alt='thinking-emoji' />
                </div>
                <div className={classes.ErrorTitle}>{title}</div>
                <div className={classes.ErrorDescription}>
                    <p>
                        {description}
                    </p>
                    <Button onClick={() => window.location.reload()}
                        btnText="Try Again"
                        className={classes.Button}
                    />
                </div>
            </div>
        );
    }


};

export default Error;